import { playerDataHttpClient } from "@sazka/ng/player/http-clients/player-data-http-client";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { BonusomatBoard } from "../models/bonusomat-board";
import { BonusomatDefaultDraw, BonusomatAllwynDraw, BonusomatTotalTickets } from "../models/bonusomat-draw";
import { BonusomatOnboarding } from "../models/bonusomat-onboarding";
import { BonusomatQuest } from "../models/bonusomat-quest";
import { BonusomatQuestDetail, BonusomatQuestGame } from "../models/bonusomat-quest-detail";
import { BonusomatSlots, BonusomatSlotsSpin, BonusomatSlotsWinTable } from "../models/bonusomat-slots";
import { SlotsWinTable } from "../models/slots-win-table";

export const fetchPlayerBoard = async (playerId: string) => {
    const response = await playerDataHttpClient.get<BonusomatBoard>(`players/${playerId}/bonusomat/board`);
    return response.data;
};

export const completePlayerBoard = async (playerId: string) => {
    const response = await playerDataHttpClient.post(`players/${playerId}/bonusomat/board/complete`);

    return response.data;
};

export const fetchPlayerDraw = async () => {
    const response = await playerDataHttpClient.get<BonusomatDefaultDraw>(`player/bonusomat/draw`);

    if (response.status == 204) {
        return null;
    }

    return response.data;
};

export const fetchPlayerAllwynDraw = async () => {
    const response = await playerDataHttpClient.get<BonusomatAllwynDraw>(`player/bonusomat/allwyn-draw`);

    if (response.status == 204) {
        return null;
    }

    return response.data;
};

export const fetchTotalTickets = async (playerId: string) => {
    const response = await playerDataHttpClient.get<BonusomatTotalTickets>(
        `players/${playerId}/bonusomat/draw/tickets`
    );

    return response.data.totalTickets;
};

export const fetchSlotsWinTable = async (playerId: string) => {
    const response = await playerDataHttpClient.get<SlotsWinTable>(`players/${playerId}/bonusomat/slots/win-table`);

    return response.data;
};

export const fetchAutomatCylinderImages = async (playerId: string) => {
    const response = await playerDataHttpClient.get<BonusomatSlots>(`players/${playerId}/bonusomat/slots`);

    return response.data;
};
export const callBonusomatSpin = async (playerId: string) => {
    const response = await playerDataHttpClient.post<BonusomatSlotsSpin>(`players/${playerId}/bonusomat/slots/spin`);

    return response.data;
};

export const fetchWinTable = async (playerId: string) => {
    const response = await playerDataHttpClient.get<BonusomatSlotsWinTable>(`players/${playerId}/bonusomat/win-table`);

    return response.data;
};

export const fetchPlayerOnboarding = async (playerId: string) => {
    const response = await playerDataHttpClient.get<BonusomatOnboarding>(`players/${playerId}/bonusomat/onboarding`);

    return response.data;
};

export const fetchQuests = async (playerId: string) => {
    const response = await playerDataHttpClient.get<BonusomatQuest[]>(`players/${playerId}/bonusomat/quests`);

    return response.data;
};

export const fetchQuestDetail = async (playerId: string, questId: number) => {
    const response = await playerDataHttpClient.get<BonusomatQuestDetail>(
        `players/${playerId}/bonusomat/quests/${questId.toString()}`
    );

    return response.data;
};

export const postActivateQuest = async (playerId: string, questId: number) => {
    const response = await playerDataHttpClient.post(`players/${playerId}/bonusomat/quests/activate`, {
        questId: questId,
    });

    return response.data;
};

export const postDeactivateQuest = async (playerId: string) => {
    const response = await playerDataHttpClient.post(`players/${playerId}/bonusomat/quests/deactivate`);

    return response.data;
};

export const postPageVisit = async (playerId: string, nodeId: number) => {
    const response = await playerDataHttpClient.post(`players/${playerId}/bonusomat/page-visit`, {
        nodeId: nodeId,
    });

    return response.data;
};

export const fetchQuestGames = async () => {
    const response = await httpClient.get<BonusomatQuestGame[]>(`/api/casino/games/bonusomat`);

    return response.data;
};
